<template>
<div class="whiteBG box-shadow">
    <div class="tableHead-title d-flex align-items-center justify-content-between mb-2">
        <label class="font-weight-bold"> Commission Per Client </label>
        <div class="rtl d-flex align-items-center">
            <ul class="selectmotr d-flex align-items-center">
                <li><a href="javascript:void(0);" v-bind:class="[ statInfoCommission.interval=='w' ? 'active' : '',]" @click.prevent="eventInterValFl('w', 'commission')">1W</a></li>
                <li><a href="javascript:void(0);" v-bind:class="[ statInfoCommission.interval=='m' ? 'active' : '',]" @click.prevent="eventInterValFl('m', 'commission')">1M</a></li>
                <li><a href="javascript:void(0);" v-bind:class="[ statInfoCommission.interval=='3m' ? 'active' : '',]" @click.prevent="eventInterValFl('3m', 'commission')">3M</a></li>
                <li><a href="javascript:void(0);" v-bind:class="[ statInfoCommission.interval=='' ? 'active' : '',]" @click.prevent="eventInterValFl('', 'commission')">All</a></li>
                <li>
                    <a href="javascript:void(0);" v-bind:class="[ statInfoCommission.interval=='custom' ? 'active' : '',]" @click.prevent=" openToggleCommission=!openToggleCommission ">Custom</a>
                    <div class="mainFilterBytime modHalf">
                        <div class="cutDropdown pt-0 px-0 pb-4" :class="openToggleCommission ? 'active' : ''">
                            <ul class="datPickerT">
                                <li class="headTitle d-flex align-items-center justify-content-between"><span>Select Date</span></li>
                                <li class="d-flex align-items-center p-3">
                                    <div class="mx-datepicker form-control whiteBG pt-0">
                                        <label>From</label>
                                        <input class="customflaotField mdb-select md-form form-control pt-0" type="date" v-model="statInfoCommission.from" name="dob1" v-validate="'required|before:beforeTarget'" :max="maxDate()" :class=" (statInfoCommission.from !='' && statInfoCommission.from !='Invalid Date' ? 'active' : '') ||{'is-invalid': submittedRequest && errors.has('dob'),}" :disabled="disable" />
                                    </div>
                                    <div class="mx-datepicker">
                                        <label>To</label>
                                        <input class="customflaotField mdb-select md-form form-control pt-0" type="date" v-model="statInfoCommission.to" name="dob2" v-validate="'required|before:beforeTarget'" :max="maxDate()" :class=" (statInfoCommission.to !='' && statInfoCommission.to !='Invalid Date' ? 'active' : '') ||{'is-invalid': submittedRequest && errors.has('dob'),}" :disabled="disable" />
                                    </div>
                                    <div class="closeIcon" @click.prevent=" openToggleCommission=!openToggleCommission; statInfoCommission.from=''; statInfoCommission.to=''; ">
                                        <feather type="x"></feather>
                                    </div>
                                </li>
                                <li class="px-3 pt-3"><a href="#" @click.prevent=" eventInterValFl('custom', 'commission') " class="grd_btn greenBG">Submit</a></li>
                            </ul>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="form-group parentClass has-search ml-2 mb-0 position-relative">
                <input type="text" placeholder="search here" class="form-control dataSearh" />
                <feather class="form-control-feedback text-right" type="search"></feather>
            </div>
            <div class="download-table-data ml-3">
                <a title="Download Data" @click.prevent=" csvExport( userCommission.records, 'client_commission', 'client_commission.csv' ) "><img src="../../../../static/fxView/images/excel.png" alt="Icon" /></a>
            </div>
        </div>
    </div>
    <div class="scrollable-x">
        <table class="table table-striped focus-on clientLst-table selectHeade">
            <thead>
                <tr>
                    <th>IB Name</th>
                    <th>Client Name</th>
                    <th>Total Volume</th>
                    <th>Total Revenue</th>
                    <th>IB Commission</th>
                    <th>Sub IB Commission</th>
                    <th>Total Commission</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(list, index) in userCommission.records" v-if="userCommission.totalRecords > 0">
                    <td v-html="list.ib_name || '-' "></td>
                    <td v-html="list.client_name || '-' "></td>
                    <!-- <td v-html=" list.ib_name !='' && list.ib_name !=null ? list.ib_name : '-' "></td>
                        <td v-html=" list.client_name !='' && list.client_name !=null ? list.client_name : '-' "></td> -->
                    <td v-html="list.totalVolume || '0' "></td>
                    <td v-html="list.totalRevenue || '0.0' "></td>
                    <td v-html="list.subIbCommission || '0.0' "></td>
                    <td v-html="list.myCommission || '0.0' "></td>
                    <td v-html="list.totalCommission || '00.0' "></td>
                </tr>
                <tr v-if="userCommission.totalRecords==0">
                    <td colspan="10">
                        <loader :pageloader_value="pageLoader" :type="'table'" :colspan="7" :list="userCommission" v-if="pageLoader==false"></loader>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <app-pagination :getList="userCommission" :pageLimit_parent="pageLimit" v-if="userCommission.totalRecords > 15"></app-pagination>
</div>
</template>

<script>
import moment from "moment";
import {
    fxViewMixins
} from "@/plugins/fxView";
export default {
    name: "AFFILIATE-EARNINGS",
    mixins: [fxViewMixins],
    data() {
        return {
            search: "",
            pageLoader: false,
            openTabledata: false,
            response_msg: "",
            msg_type: "",
            page: "1",
            pageLimit: 15,
            statusCls: "",
            disable: false,
            openToggle: false,
            openToggleTransaction: false,
            openToggleCommission: false,
            submittedRequest: false,
            statInfo: {
                interval: "",
                from: "",
                to: "",
            },
            statInfoCommission: {
                interval: "",
                from: "",
                to: "",
            },
            statInfoTransaction: {
                interval: "",
                from: "",
                to: "",
            },
        };
    },
    methods: {
        maxDate() {
            return moment().format("YYYY-MM-DD");
        },
        eventInterValFl(interval, eventType) {
            if (eventType == "commission") {
                this.statInfoCommission.interval = interval;
                if (this.statInfoCommission.interval != "custom") {
                    this.statInfoCommission.from = this.statInfoCommission.to = "";
                    this.userListing();
                } else if (
                    this.statInfoCommission.interval == "custom" &&
                    this.statInfoCommission.from != "" &&
                    this.statInfoCommission.to != ""
                ) {
                    this.userListing();
                    //this.openToggleCommission = !this.openToggleCommission
                } else if (this.statInfoCommission.interval == "") {
                    this.userListing();
                }
            }
        },
        getHumanDate(date) {
            // return this.$parent.dateDDMMFormat(date);
        },
        getCommissionStatus(status) {
            //console.log("status",status)
            let statusMsg = "";
            if (status == 0) {
                statusMsg = "Pending";
                this.statusCls = "alert-warning";
            } else if (status == 1) {
                statusMsg = "Approved";
                this.statusCls = "alert-success";
            } else if (status == 2) {
                statusMsg = "Denied";
                this.statusCls = "alert-danger";
            } else {
                statusMsg = "-";
            }
            return statusMsg;
        },
        userListing() {
            let inputJson = {
                globalParams: {
                    filter: {},
                    sort: [],
                    search: this.search,
                    page: this.page,
                    perPage: this.pageLimit,
                    stat_interval: this.statInfoCommission.interval,
                    stat_from_interval: this.statInfoCommission.from,
                    stat_to_interval: this.statInfoCommission.to,
                },
                localParams: {
                    parameter: this
                },
            };
            this._runGetUserCommission(inputJson);
        },
        csvExport(arrData, type, getFileName) {
            let csv = "data:text/csv;charset=utf-8,";
            //console.log("data",arrData)
            const _that = this;
            if (type == "history_transaction") {
                csv += "Date,Method,Amount,Fee,Total,Status \n";
                arrData.forEach(function (row) {
                    csv +=
                        _that.getHumanDate(row.created) +
                        "," +
                        "-" +
                        "," +
                        row.req_amount +
                        "," +
                        0 +
                        "," +
                        row.req_amount +
                        "," +
                        _that.getCommissionStatus(row.commission_success_status);
                    csv += "\n";
                });
            } else if (type == "client_commission") {
                csv +=
                    // "Registration Date,Client Name,Email,Country,Sub-Aff. Name,Volume Traded,Total Commission,Sub-Affiliate Comm.,My Comm.,Status \n";
                    "IB Name,Client Name,Total volume,Total Revenue,sub Ib Commission,My Comm.,Total Commission,Status \n";
                arrData.forEach(function (row) {
                    let status = row.status == 1 ? "Active" : "Inactive";
                    csv +=
                        // _that.getHumanDate(row.created) +
                        // "," +
                        // row.firstname +
                        // "," +
                        // row.email +
                        // "," +
                        // row.country +
                        // "," +
                        // row.RMname +
                        // "," +
                        row.ib_name +
                        "," +
                        row.client_name +
                        "," +
                        row.totalVolume +
                        "," +
                        row.totalRevenue +
                        "," +
                        row.subIbCommission +
                        "," +
                        row.myCommission +
                        "," +
                        row.totalCommission +
                        "," +
                        status;
                    csv += "\n";
                });
            } else if (type == "monthly_transaction") {
                csv +=
                    "Month,Revenue,Tier,Commission Earned,Sub-Affiliate,Total Commission \n";
                arrData.forEach(function (row) {
                    csv +=
                        _that.getHumanDate(row.date) +
                        ",$" +
                        row.totalRevenue +
                        "," +
                        row.slab +
                        ",$" +
                        row.myCommission +
                        ",$" +
                        row.subIbCommission +
                        ",$" +
                        (row.myCommission + row.subIbCommission);
                    csv += "\n";
                });
            }

            //display the created CSV data on the web browser
            //document.write(csv);

            const link = document.createElement("a");
            const data = encodeURI(csv);
            link.setAttribute("href", data);
            link.setAttribute("download", getFileName);
            //console.log("link",link)
            link.click();
        },
    },
    created() {
        this.userListing();
    },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/ib/commission-per-client.vue